/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useState} from 'react'
import {CardLoading} from '../loading/CardLoading'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {ModalEnterprises} from '../../../../app/pages/sgt/property/components/modal/ModalEnterprises'
import {ModalFields} from '../../../../app/pages/sgt/property/components/modal/ModalFields'
import {ModalLinkedLicenses} from '../../../../app/pages/sgt/property/components/modal/ModalLinkedLicenses'

type Props = {
  className: string
  name: string
  city: string
  UF: string
  fields?: any
  regularized: any
  owners?: string
  enterprises: any
  linkedLicenses?: any
  contract?: any
  file?: string
}

const CardSystemWidgetSGT: React.FC<Props> = ({
  className,
  fields,
  UF,
  name,
  enterprises,
  owners,
  linkedLicenses,
  regularized,
  contract,
  city,
  file,
}) => {
  const intl = useIntl()
  const [showEnterprisesModal, setShowEnterprisesModal] = useState<boolean>(false)
  const [showFieldsModal, setFieldsModal] = useState<boolean>(false)
  const [showLinkedLincensesModal, setLinkedLincensesModal] = useState<boolean>(false)

  return (
    <div
      className={`card ${className} 
          border          
          border-gray-300
          `}
    >
      {/* begin::Body */}
      <div className='container-fluid  pb-0 p-3 '>
        {name ? (
          <>
            {/* begin::Row */}
            {/* begin::Col */}
            <div className='col-xl-12 p-3 pb-0'>
              <p className='mt-0 mb-4 fs-3 fw-bold'>
                {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
              </p>
            </div>

            <div className='row p-3'>
              {/* Inicio coluna 01 */}
              <div className='col justify-content-center'>
                <div className='fw-semibold fs-8  '>
                  {intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                  <p className='text-primary fs-8'>{name}</p>
                </div>
                <div className='fw-semibold fs-8  '>
                  {intl.formatMessage({id: 'ENTERPRISES.TITLE'})}
                  <p className='text-primary fs-8'>
                    {enterprises.length}
                    <a
                      href='#'
                      onClick={() => setShowEnterprisesModal(true)}
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_enterprises'
                      type='button'
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    </a>
                  </p>

                  {enterprises ? (
                    <>
                      <ModalEnterprises
                        id='enterprisesModal'
                        show={showEnterprisesModal}
                        handleClose={() => setShowEnterprisesModal(false)}
                        enterprises={enterprises}
                      />
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              {/* Final coluna 01 */}

              {/* Inicio coluna 02 */}
              <div className='col justify-content-center'>
                <div className='fw-semibold fs-8   '>
                  {intl.formatMessage({id: 'COMMON.INPUT_CITY_SECTOR'})}
                  {/* <div className='text-primary'>{fields}</div> */}
                  <p className='text-primary fs-8 '>{city}</p>
                </div>
                <div className='col  fw-semibold fs-8  '>
                  {intl.formatMessage({id: 'OWNERS.TITLE'})}
                  <p className='text-primary fs-8'>
                    {owners?.length}
                    {owners ? (
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    ) : (
                      ''
                    )}
                  </p>
                </div>
              </div>
              {/* Final coluna 02 */}

              {/* Inicio coluna 03 */}
              <div className='col justify-content-center p-1'>
                <div className=' fw-semibold fs-8   '>
                  {intl.formatMessage({id: 'COMMON.INPUT_UF'})}
                  <p className='text-primary fs-8'>{UF}</p>
                </div>
                <div className='fw-semibold fs-8  '>
                  {/* {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})} */}
                  Contratos
                  {/* <div className='text-primary'>{fields}</div> */}
                  <p className='text-primary fs-8 '>
                    {contract.length}
                    {contract ? (
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    ) : (
                      ''
                    )}
                  </p>
                </div>
              </div>
              {/* Final coluna 03 */}

              {/* Inicio coluna 04 */}
              <div className='col justify-content-center'>
                <div className=' fw-semibold fs-8  mb-xl-0  '>
                  {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
                  <p className='text-primary fs-8'>
                    {fields?.length}
                    <a
                      href='#'
                      onClick={() => setShowEnterprisesModal(true)}
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_fields'
                      type='button'
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    </a>
                  </p>
                  {fields ? (
                    <>
                      <ModalFields
                        id='fieldsModal'
                        show={showFieldsModal}
                        handleClose={() => setFieldsModal(false)}
                        fields={fields}
                      />
                    </>
                  ) : (
                    ''
                  )}
                </div>
                <div className=' fw-semibold fs-8   '>
                  {intl.formatMessage({id: 'MENU.LINKED_LICENSE'})}
                  <p className='text-primary fs-8'>
                    {linkedLicenses?.length}
                    <a
                      href='#'
                      onClick={() => setLinkedLincensesModal(true)}
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_linkedLincenses'
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    </a>
                  </p>
                  {linkedLicenses ? (
                    <>
                      <ModalLinkedLicenses
                        id='linkedLicensesModal'
                        show={showLinkedLincensesModal}
                        handleClose={() => setLinkedLincensesModal(false)}
                        linkedLicenses={linkedLicenses}
                      />
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              {/* Final coluna 04 */}

              {/* Inicio coluna 05 */}
              <div className='col fw-semibold fs-8  '>
                {intl.formatMessage({id: 'PROPERTIES.REGULARIZED'})}

                <p className='text-primary fs-8 '>Sim</p>
              </div>
              {/* Final coluna 05 */}
            </div>
          </>
        ) : (
          <CardLoading />
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetSGT}
